"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTypes = exports.isProcvDatasourceConfigRequest = exports.isProcvDatasourceConfig = void 0;
const isProcvDatasourceConfig = (cfg) => {
    return cfg !== null && 'base_tab_id' in cfg && 'joins' in cfg;
};
exports.isProcvDatasourceConfig = isProcvDatasourceConfig;
const isProcvDatasourceConfigRequest = (cfg) => {
    return 'joins' in cfg;
};
exports.isProcvDatasourceConfigRequest = isProcvDatasourceConfigRequest;
var OrderTypes;
(function (OrderTypes) {
    OrderTypes["ASC"] = "asc";
    OrderTypes["DESC"] = "desc";
})(OrderTypes = exports.OrderTypes || (exports.OrderTypes = {}));
